import { useTranslation } from 'react-i18next'

import { IconNG } from '../../../Icon'

import * as styles from './EpostFormFieldsRadioLabel.module.css'

function EpostFormFieldsRadioLabel({ Icon, text }) {
  const { t } = useTranslation()

  return (
    <>
      <IconNG Icon={Icon} />
      <span className={styles.text}>{t(text)}</span>
    </>
  )
}

export default EpostFormFieldsRadioLabel
